/** A pin worth showing: both numbers present and finite, and not the 0,0 "unset" default. */
export function hasCoordinates(lat: unknown, lon: unknown): boolean {
  if (lat === null || lat === undefined || lat === '' || lon === null || lon === undefined || lon === '') return false;
  const a = Number(lat);
  const b = Number(lon);
  return Number.isFinite(a) && Number.isFinite(b) && Math.abs(a) <= 90 && Math.abs(b) <= 180 && !(a === 0 && b === 0);
}

/** These coordinates in Google Maps (Street View and nearby places are a click away there). */
export function googleMapsUrl(lat: unknown, lon: unknown): string {
  return `https://www.google.com/maps/search/?api=1&query=${Number(lat)},${Number(lon)}`;
}

/** Six decimal places (about 10 cm), as the host wizard stores a dragged pin. */
export const roundCoordinate = (n: number): number => +n.toFixed(6);

/** Straight-line distance between two spots, in metres (haversine; plenty for "how far apart are these pins"). */
export function distanceMeters(a: { lat: number; lon: number }, b: { lat: number; lon: number }): number {
  const rad = (d: number) => (d * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLon = rad(b.lon - a.lon);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLon / 2) ** 2;
  return 2 * 6_371_000 * Math.asin(Math.sqrt(h));
}
